import {
  GET_CLIENT_REQUEST,
  GET_CLIENT_SUCCESS,
  GET_CLIENT_FAIL,
  GET_TEAM_BY_CLIENT_REQUEST,
  GET_TEAM_BY_CLIENT_SUCCESS,
  GET_TEAM_BY_CLIENT_FAIL,
  GET_SINGLE_CLIENT_REQUEST,
  GET_SINGLE_CLIENT_SUCCESS,
  GET_SINGLE_CLIENT_FAIL,
  CREATE_CLIENT_REQUEST,
  CREATE_CLIENT_SUCCESS,
  CREATE_CLIENT_FAIL,
  UPDATE_CLIENT_REQUEST,
  UPDATE_CLIENT_SUCCESS,
  UPDATE_CLIENT_FAIL,
  DELETE_CLIENT_REQUEST,
  DELETE_CLIENT_SUCCESS,
  DELETE_CLIENT_FAIL,
  CLEAR_CLIENT_RECORD,
} from "../constant/ClientConstant";

const initialState = {
  loading: false,
  action: "CLIENT",
  result: [],
  teambyclient: [],
  success: false,
  singledata: [],
  message: "",
  error: "",
};

const ClientReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CLIENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_CLIENT_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload.data.list,
        message: action.message,
      };

    case GET_CLIENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };

    case GET_SINGLE_CLIENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_TEAM_BY_CLIENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_TEAM_BY_CLIENT_SUCCESS:
      return {
        ...state,
        loading: false,
        teambyclient: action.payload.data.list,
        message: action.message,
      };

    case GET_TEAM_BY_CLIENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };

    case GET_SINGLE_CLIENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_SINGLE_CLIENT_SUCCESS:
      return {
        ...state,
        loading: false,
        singledata: action.payload.data,
        message: action.message,
      };
    case GET_SINGLE_CLIENT_FAIL:
      return {
        loading: false,
        error: action.error,
        message: action.message,
      };

    case CREATE_CLIENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CREATE_CLIENT_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        result: state.result.filter((items) =>
          items.id === action.payload.id
            ? Object.assign({}, items, action.payload)
            : items
        ),
        message: action.message,
      };

    case CREATE_CLIENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };

    case UPDATE_CLIENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_CLIENT_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        result: state.result.map((items) =>
          items.id === action.payload.id
            ? Object.assign({}, items, action.payload)
            : items
        ),
        message: action.message,
      };
    case UPDATE_CLIENT_FAIL:
      return {
        ...state,
        loading: false,
        message: action.message,
        error: action.error,
      };
    case DELETE_CLIENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_CLIENT_SUCCESS:
      return {
        ...state,
        loading: false,
        result: state.result.filter((item) => item.id !== action.payload.id),
        message: action.message,
      };
    case DELETE_CLIENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };

    case CLEAR_CLIENT_RECORD:
      return {
        ...state,
        loading: false,
        success: false,
        result: [],
        singledata: [],
        message: action.message,
      };
    default:
      return state;
  }
};

export default ClientReducer;
